import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {StockTakeExportReportData} from "./stock-take-export-report.data";

@Injectable()
export class StockTakeExportReportModel extends ReportModel<StockTakeExportReportData> {
    constructor(injector: Injector) {
        super(injector, StockTakeExportReportData);
    }
}
